import {
  Cake,
  Sparkles,
  Heart,
  X,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { TeamCelebration } from "@shared/teamCelebrations";
import "./teamCelebrations.css";

export function TeamCelebrationCard({
  item,
  position,
  count,
  own,
  busy,
  onClose,
  onPrevious,
  onNext,
}: {
  item: TeamCelebration;
  position: number;
  count: number;
  own: boolean;
  busy?: boolean;
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
}) {
  const birthday = item.kind === "birthday";
  const Icon = birthday ? Cake : Heart;
  const initials = item.name
    .split(/\s+/)
    .map(word => word[0])
    .slice(0, 2)
    .join("");
  return (
    <section
      className={`team-celebration ${birthday ? "is-birthday" : "is-anniversary"}`}
      aria-label={`${birthday ? "День рождения" : "Годовщина работы"}: ${item.name}`}
    >
      <div className="celebration-decoration" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
        <i />
      </div>
      <header className="celebration-eyebrow">
        <span>
          <Icon size={15} strokeWidth={1.7} />{" "}
          {birthday ? "День рождения" : "Ещё один год вместе"}
        </span>
        <button
          className="celebration-icon-button"
          aria-label="Скрыть поздравление на сегодня"
          onClick={onClose}
          disabled={busy}
        >
          <X size={17} />
        </button>
      </header>
      <div className="celebration-hero">
        <Avatar className="celebration-photo">
          <AvatarImage
            src={item.picture || undefined}
            alt={item.name}
            referrerPolicy="no-referrer"
          />
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div>
          <p className="celebration-today">Сегодня в Change HR</p>
          <h2>
            {own && birthday ? `С днём рождения, ${item.name}!` : item.title}
          </h2>
        </div>
      </div>
      <p className="celebration-message">{item.message}</p>
      <footer className="celebration-footer">
        <span className="celebration-signature">
          <Sparkles size={14} />{" "}
          {own ? "С теплом, твоя команда" : "Поздравляем всей командой"}
        </span>
        {count > 1 && (
          <nav
            className="celebration-pagination"
            aria-label="Поздравления сегодня"
          >
            <button
              className="celebration-icon-button"
              onClick={onPrevious}
              aria-label="Предыдущее поздравление"
            >
              <ChevronLeft size={16} />
            </button>
            <span>
              {position + 1} / {count}
            </span>
            <button
              className="celebration-icon-button"
              onClick={onNext}
              aria-label="Следующее поздравление"
            >
              <ChevronRight size={16} />
            </button>
          </nav>
        )}
      </footer>
    </section>
  );
}
